export default "__VITE_ASSET__DYEfoc3L__"